import React from "react";
import styled from "styled-components";
import { colors } from "../../../../utils/theme";
import { TextView } from "../../..";
import { ASSETS } from "../../../../utils/config";

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 20px;
`;

const AlignmentImage = styled.img`
  overflow: hidden;
`;

const Wrapper = styled.div`
  cursor: pointer;
  padding: 4px;
  border: 1px solid;
  border-color: ${({ selected }) =>
    selected ? colors.purple : colors.lightGrey};
  margin-right: 12px;
  border-radius: 8px;
  background-color:${({ selected }) =>
    selected ? colors.transparentPurple: "none"};
`;

const BlockAlignment = ({ selectedAlignment, setSelectedAlignment,style }) => {
  const alignments = [
    { name: "left", imgSrc: ASSETS.segmentEditor.LeftAlignment },
    { name: "center", imgSrc: ASSETS.segmentEditor.CenterAlignment },
    { name: "right", imgSrc: ASSETS.segmentEditor.RightAlignment },
  ];

  return (
    <div style={style}>
      <TextView variant="subtitle">Alignment</TextView>
      <Container>
        {alignments.map((alignment, index) => (
          <Wrapper selected={selectedAlignment === alignment.name}>
            {" "}
            <AlignmentImage
              key={index}
              onClick={() => setSelectedAlignment(alignment.name)}
              src={alignment.imgSrc}
              alt={alignment.name}
            />
          </Wrapper>
        ))}
      </Container>
    </div>
  );
};

export default BlockAlignment;
